import { useEffect, useState } from 'react';
import DbUserService from '../../services/DbUserService';
import DbDatabases from '../../types/DbDatabases';

export default function useDatabases(uuid: string | undefined) {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);
    const [databases, setDatabases] = useState<DbDatabases | undefined>(
        undefined
    );

    const load = async () => {
        if (uuid) {
            setLoading(true);

            try {
                const details = await DbUserService.getAllDatabases(uuid);
                setDatabases(details);
                setLoading(false);
                setError(null);
            } catch (e: any) {
                setLoading(false);
                setError(e);
            }

            setLoading(false);
        }
    };

    const refresh = () => {
        load();
    };

    useEffect(() => {
        refresh();
    }, [uuid]);

    return { databases, refresh, loading, error };
}
